module.exports = __webpack_public_path__ + "img/baojia3.091912dc.png";